import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Demo from './components/Demo';
import TheProblem from './components/TheProblem';
import HowItWorks from './components/HowItWorks';
import Differentiation from './components/Differentiation';
import Team from './components/Team';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';

// Lazy load blog components to prevent them from crashing the main app
const Blog = React.lazy(() => import('./components/Blog'));
const BlogPost = React.lazy(() => import('./components/BlogPost'));

function HomePage() {
  return (
    <>
      <Hero />
      {/* <Demo /> */}
      <TheProblem />
      <HowItWorks />
      <Differentiation />
      <Team />
      <FAQ />
      <CTA />
    </>
  );
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '4rem 2rem', textAlign: 'center', color: '#fff' }}>
          <p style={{ fontFamily: 'monospace', color: '#ff3333' }}>Something went wrong.</p>
          <a href="/" style={{ color: '#00ffd5', fontFamily: 'monospace', fontSize: '0.8rem' }}>
            Go home
          </a>
        </div>
      );
    }
    return this.props.children;
  }
}

const BlogFallback = () => (
  <div className="min-h-screen bg-[#020204] flex items-center justify-center pt-24">
    <div className="flex items-center gap-3">
      <div className="w-2 h-2 bg-[#00ffd5] animate-pulse" />
      <span className="font-mono text-sm text-white/40 tracking-widest uppercase">Loading</span>
    </div>
  </div>
);

function App() {
  return (
    <div className="App min-h-screen scan-line noise-bg">
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/blog"
            element={
              <ErrorBoundary>
                <Suspense fallback={<BlogFallback />}>
                  <Blog />
                </Suspense>
              </ErrorBoundary>
            }
          />
          <Route
            path="/blog/:slug"
            element={
              <ErrorBoundary>
                <Suspense fallback={<BlogFallback />}>
                  <BlogPost />
                </Suspense>
              </ErrorBoundary>
            }
          />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
